import React from "react";
import { isUndefined } from "lodash";

interface IFileSection {
  id: string;
  onFileSelected?(files: FileList | null): void;
}

const FileSection = React.forwardRef(
  (
    { id, onFileSelected }: IFileSection,
    ref?: React.LegacyRef<HTMLInputElement>
  ) => {
    const _inputType = "file";
    const _acceptType = ".xlsx, .xls";
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onFileSelected!(event.target.files);
    };

    const onInputClick = (event: any) => {
      event.target.value = "";
    };

    if (isUndefined(onFileSelected)) {
      return null;
    }
    return (
      <input
        ref={ref}
        id={id}
        accept={_acceptType}
        type={_inputType}
        style={{ display: "none" }}
        onChange={handleOnChange}
        onClick={onInputClick}
      />
    );
  }
);

export default FileSection;
